@if (!inputService.hidden && inputService.formInputDefinition && inputService.control) {
  <ng-container [formGroup]="inputService.formGroup">
    <mat-form-field [appearance]='inputService.inputConfig.appearence' [floatLabel]='inputService.formInputDefinition.placeholder ? "always" : "auto"'>
      <mat-label>
        @if (inputService.exportEAgency) {
          <img matTooltip='Esportato in eAgency' class='title-input-eagency' src='assets/images/logos/logo_eagency.png'/>
        }
        @if (inputService.formInputDefinition.titleIcon) {
          <mat-icon class='title-input-icon' [matTooltip]='inputService.formInputDefinition.titleTooltip'>{{inputService.formInputDefinition.titleIcon}}</mat-icon>
        }
        <span>{{inputService.computedTitle | translate}}</span>
      </mat-label>
      <div class="flex-row flex-gap-16 items-center justify-between">
        @if (!inputService.inputConfig.readOnly) {
          <div class="counter-btn" (click)="sub()" [ngClass]="{'counter-btn_disabled':!canSub}">
            <mat-icon>remove</mat-icon>
          </div>
        }
        <input
          [required]='inputService.inputConfig.required'
          [readonly]='inputService.inputConfig.readOnly'
          [name]='inputService.formControlKey'
          [autocomplete]="'nope_' + inputService.formControlKey"
          type='number'
          matInput
          [placeholder]="(inputService.inputConfig.placeholder || '') | translate"
          [formControlName]='inputService.formControlKey'
          [min]="minValue"
          >
        @if (!inputService.inputConfig.readOnly) {
          <div class="counter-btn" (click)="add()" [ngClass]="{'counter-btn_disabled':!canAdd}">
            <mat-icon>add</mat-icon>
          </div>
        }
      </div>
      @if (inputService.inputConfig.hint) {
        <mat-hint>{{inputService.inputConfig.hint}}</mat-hint>
      }
      @if (!inputService.control.valid && inputService.errorMessage) {
        <mat-error>{{inputService.errorMessage | translate}}</mat-error>
      }
    </mat-form-field>
  </ng-container>
}